import { useEffect, useState } from 'react';
import type { ComponentType } from 'react';
import type { LottieComponentProps } from 'lottie-react';

let lottieComponentPromise: Promise<ComponentType<LottieComponentProps>> | null = null;

const loadLottieComponent = () => {
  lottieComponentPromise ??= import('lottie-react').then(({ default: Lottie }) => Lottie);

  return lottieComponentPromise;
};

export const LazyLottie = (props: LottieComponentProps): JSX.Element | null => {
  const [LottieComponent, setLottieComponent] = useState<ComponentType<LottieComponentProps> | null>(null);

  useEffect(() => {
    let mounted = true;

    loadLottieComponent()
      .then((Lottie) => {
        if (mounted) setLottieComponent(() => Lottie);
      })
      .catch(() => {
        if (mounted) setLottieComponent(null);
      });

    return () => {
      mounted = false;
    };
  }, []);

  if (!LottieComponent) return null;

  return <LottieComponent {...props} />;
};

export type { LottieComponentProps, LottieRefCurrentProps } from 'lottie-react';
